import {
  type DatabaseField,
  DatabaseFieldType,
  type DatabaseValue,
  type SelectOption
} from '@databases/types/database';

import { DatabaseGroup } from './database-group.ts';

export class DatabaseGroupSelectField extends DatabaseGroup<DatabaseFieldType.SELECT> {
  get fieldSelectOptions(): SelectOption[] {
    return this.groupField.settings.selectOptions;
  }

  private static findSelectOptionForValue(
    selectedValue: string,
    selectOptions?: SelectOption[]
  ): SelectOption | undefined {
    return (
      selectOptions?.find((option) => option.id === selectedValue) ??
      selectOptions?.find((option) => option.label === selectedValue)
    );
  }

  get selectOption(): SelectOption | undefined {
    return DatabaseGroupSelectField.findSelectOptionForValue(
      this.key,
      this.fieldSelectOptions
    );
  }

  override get displayValue(): string | undefined {
    return this.selectOption?.label;
  }

  static generateKeyForFieldValue(
    fieldValue: DatabaseValue<DatabaseFieldType.SELECT>,
    selectOptions?: SelectOption[]
  ): string {
    const values = Array.isArray(fieldValue.value)
      ? fieldValue.value
      : [fieldValue.value];
    const selectedValue =
      values.find((value) => {
        if (value !== '') {
          return true;
        }

        return DatabaseGroupSelectField.findSelectOptionForValue(value, selectOptions);
      }) ?? values[0];
    const selectedOption =
      selectedValue !== undefined
        ? DatabaseGroupSelectField.findSelectOptionForValue(selectedValue, selectOptions)
        : undefined;

    return selectedOption?.id ?? selectedOption?.label ?? selectedValue ?? '';
  }

  static createFromSelectOption(
    option: SelectOption,
    groupField: DatabaseField<DatabaseFieldType.SELECT>
  ) {
    const optionId = option.id ?? option.label;
    return new DatabaseGroupSelectField(optionId, groupField, {
      type: DatabaseFieldType.SELECT,
      value: [optionId]
    });
  }
}
